import { render, staticRenderFns } from "./CreateDestination.vue?vue&type=template&id=4d037bfe&"
import script from "./CreateDestination.vue?vue&type=script&lang=js&"
export * from "./CreateDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateDestination.vue"
export default component.exports